<script setup></script>

<template>
	<div class="flex flex-col">
		<img src="https://cdn.papercrowns.com/website/images/elements/accents/top-scroll-fin.png" alt="" />
		<div class="bg-[url('https://cdn.papercrowns.com/website/images/elements/accents/middle-scroll-fin.png')] bg-contain bg-repeat-y py-5 pl-[12vw] pr-[8vw] sm:pl-[4.5rem] sm:pr-12 md:pl-16 md:pr-12 lg:pl-[5.5rem] lg:pr-16 xl:pl-[4.25rem] xl:pr-12 2xl:pl-20 2xl:pr-14 3xl:pl-24 3xl:pr-16">
			<slot />
		</div>
		<img src="https://cdn.papercrowns.com/website/images/elements/accents/bottom-scroll-fin.png" alt="" />
	</div>
</template>
